import { categories, categoryIcons } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Featured Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Explore our organized product collections — from sneakers and streetwear to accessories and electronics. Each category opens a curated spreadsheet on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg border border-background-200/60 bg-background-50 hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer overflow-hidden"
            >
              <div className="w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex flex-col items-center text-center">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-2">
                  <i className={`${categoryIcons[cat.name] || "ri-folder-line"} text-base md:text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  Browse <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}